"use client";

import { useEffect, useState } from "react";
import { Icon } from "@/components/ui/Icon";
import { Chip } from "@/components/ui/primitives";
import { raceClock } from "@/lib/leaderboards/format";

/* The kit's "Ends in" badge under the race title, ticking once a second.
   The clock only starts after mount: the server cannot know the visitor's
   moment, and a time rendered twice would never match. */
export function RaceCountdown({ from, to, status }: { from: string; to: string; status: string }) {
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Chip className="gap-[6px] tabular-nums">
      <Icon name="clock" size={12} />
      <span suppressHydrationWarning>{now === null ? "…" : raceClock(now, { from, to, status })}</span>
    </Chip>
  );
}
